import { selectBasicDeliveryDefaults } from "@sellar-io/common";
import { useEffect } from "react";
import { useCustomerZonesList } from "./api/v2/customerZones/useCustomerZonesList";

export const useBasicDeliveryDefaults = (enabled: boolean) => {
  const query = useCustomerZonesList({ limit: 50 }, { enabled });
  const { hasNextPage, isFetchingNextPage, fetchNextPage, isError } = query;
  useEffect(() => {
    if (enabled && hasNextPage && !isFetchingNextPage && !isError) {
      void fetchNextPage();
    }
  }, [enabled, hasNextPage, isFetchingNextPage, fetchNextPage, isError]);
  const defaults = selectBasicDeliveryDefaults(query.data?.pages.flat() ?? []);
  return {
    query,
    ...defaults,
    isLoading: !isError && (query.isLoading || query.hasNextPage),
  };
};
